// @ts-nocheck
import React from 'react';
import DateView from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Field, ErrorMessage } from 'formik';
import TextError from '../common/TextError';
import customStyle from '../../assets/css/modular/custom-form.module.css';

export default function CustomDatePicker(props){
    const { label, name, required, ...rest } = props;

    //Custom DatePicker
    return (
        <div className={`form-control ${customStyle.custom_form}`}>
            <label className={customStyle.custom_label} htmlFor={name}>{label} {required == true ? <span className='required'>*</span> : '' }</label>
            <Field id={name} name={name} {...rest} />
            <ErrorMessage name={name} component={TextError} />
        </div>
    )
}
